import { BlogCtaCardFragmentFragment } from '../../../__generated__/graphql';
import Card from '../Card';

interface BlogCtaCardForPostProps {
  fragment: BlogCtaCardFragmentFragment;
}

const BlogCtaCardForPost = ({ fragment }: BlogCtaCardForPostProps) => {
  const contentBlockProps = fragment.blogCtaCard;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Card
      buttonLinkFragment={contentBlockProps.button}
      description={contentBlockProps.description}
      id={contentBlockProps.sectionId}
      image={contentBlockProps.image}
      pageType="post"
      title={contentBlockProps.title}
    />
  );
};

export default BlogCtaCardForPost;
